<template>
    <rkm-area
        type="fieldset"
        title="Recusa do cadastro domiciliar da atenção básica"
    >
        <rkm-row v-if="data.model">
            <rkm-col cols="12">

                <rkm-form-checkbox
                    :value="true"
                    v-model="data.model.recusaCadastro"
                    @change="confirmRecusa()"

                >
                    Usuário recusou o cadastro por meio do termo de Recusa do Cadastro
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>

export default {
    data: () => ({
        residencia: {
            situacaoDomicilioId: null,
            domicilioZonaId: null,
            domicilioTipoId: null,
            moradores: '',
            quantidadeComodos: '',
            situacaoRuralId: null,
            domicilioTipoAcessoId: null,
            materialPredominanteId: null,
            energiaEletrica: null,
            abastecimentoId: null,
            tratamentoId: null,
            destinoLixoId: null,
            formaEscoamentoId: null,
            possuiAnimais: null,
            animal: [],
            quantidadeAnimais: ''
        },
        instituicao: {
            nome: '',
            outrosProfissionais: null,
            nomeResponsavelTecnico: '',
            cnsResponsavelTecnico: '',
            cargoResponsavelTecnico: '',
            telefoneResponsavelTecnico: ''
        }
    }),
    methods: {
        handleRecusaCadastro() {

            if (this.data.model.recusaCadastro) {

                Object.keys(this.instituicao).forEach((key) => {
                    this.data.model.instituicao[key] = this.instituicao[key];
                });

                Object.keys(this.residencia).forEach((key) => {
                    this.data.model.residencia[key] = this.residencia[key];
                });
            }
        },
        confirmRecusa() {

            if (this.data.model.recusaCadastro) {

                this.showConfirmation(
                    'Ao recusar o cadastro, as informações referentes à residência e à instituição serão apagadas. Deseja continuar?',
                    async () => this.handleRecusaCadastro(),
                    async () => this.data.model.recusaCadastro = false,
                )
            }
        },
    },
    props: {
        data: { type: Object, required: false, },
    }
}
</script>